<template>
  <ed-input-item :label="label" :info="info" :name="name" :required="required">
    <el-input
      autocomplete="false"
      :value="value"
      :name="name"
      :type="type"
      :maxlength="maxlength"
      :clearable="clearable"
      :readonly="readonly"
      :disabled="disabled"
      :prefix-icon="iconLeft"
      :rules="rules"
      @input="$emit('input', $event)"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      @change="$emit('change', $event)"
      v-mask="'99:99'"
      placeholder="hh:mm"
    />
  </ed-input-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputItem from "./EdInputItem";

export default {
  name: "EdInputText",
  mixins: [EdFormMixin],
  components: { EdInputItem },
  props: {
    type: {
      type: String,
      required: false,
      default: "text",
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: 99999,
    },
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// EdInputTime.vue?6ed4595b